import { text_colorTextSecondary } from 'ext-ui/style/colors'
import React, { SVGProps } from 'react'
import SvgBillPayNew from 'src/components/Svgs/SvgBillPayNew'

// Bill Pay sidenav glyph — deliberately the SAME "bill-pay-new" Figma
// component the create-new menu's "Pay by ACH" item renders (🧩 Navigation,
// 2337-12051 "Variant=Bill Pay, Selected=False"), per EX-40842.
//
// SvgBillPayNew pads its viewBox to shrink the glyph into the create-new
// menu's 24x24 slot; the sidenav instead fills its 20x20 box, so the viewBox
// is re-tightened here. The glyph's real bounds are 20 wide x 20.879 tall
// (measured, not assumed), so a square 0 0 20 20 box would clip the bottom of
// the dollar circle — the box is squared to the taller edge and the glyph
// centred horizontally by -0.44.
const SvgSidenavBillPay = ({
  fill,
  ...rest
}: SVGProps<SVGSVGElement>): React.ReactElement => (
  <SvgBillPayNew
    {...rest}
    width={20}
    height={20}
    viewBox="-0.44 0 20.879 20.879"
    fill={fill || text_colorTextSecondary}
  />
)

export default SvgSidenavBillPay
